import { CONTAINER_ID, SESSION_COLLAPSED, SESSION_FORCED_VARIATIONS } from '../constants';
import { ABTASTY_QA_PLATFORM_URL } from '@src/shared/constants';
import { HandlerMessageFromIframe } from '../handleIframeMessage/handleIframeMessage';

const memo: {
  messageListenerCallback: HandlerMessageFromIframe | null;
} = {
  messageListenerCallback: null,
};

export const closeQAAssistant = () => {
  // let the tag use its own allocation
  sessionStorage.removeItem(SESSION_FORCED_VARIATIONS);
  sessionStorage.removeItem(SESSION_COLLAPSED);
  sessionStorage.removeItem(ABTASTY_QA_PLATFORM_URL);
  sessionStorage.removeItem('AB_TASTY_QA_ASSISTANT_ENV');
  document.getElementById(CONTAINER_ID)!.remove();

  if (memo.messageListenerCallback) {
    window.removeEventListener('message', memo.messageListenerCallback);
    memo.messageListenerCallback = null;
  }
};

export const initCloseQAAssistant = (messageListenerCallback: HandlerMessageFromIframe) => {
  memo.messageListenerCallback = messageListenerCallback;
};
